<template>
    <div>
        <change-two-factor-authentication-form></change-two-factor-authentication-form>
    </div>
    </template>

    <script>
    export default {}
    </script>
    